import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

@Injectable()
export class LocationService {
    constructor(private http: HttpClient) {
    }


    show(id) {
        return this.http.get<any>(`${environment.apiUrl}/client/show/${id}`);
    }

    store(location) {
        return this.http.post<any>(`${environment.apiUrl}/project/storeLocation`, location);
    }

    update(client) {
        return this.http.put<any>(`${environment.apiUrl}/client/${client.id}` , client);
    }

    delete(id: number) {
        return this.http.delete<any>(`${environment.apiUrl}/client/${id}`);
    }

    getLocations(name = '', clientId?: number) {
        // JS-1920 (2026-10-21): optional client scope lets the embedded Dashboard load locations
        // for a specific client (used by the client profile Locations tab) regardless of whether
        // the caller is a client user or an agency viewer.
        const clientPart = clientId ? `&client_id=${clientId}` : '';
        return this.http.get<any>(`${environment.apiUrl}/project/location?search=${name}${clientPart}`);
    }

    deleteLocation(param) {
        return this.http.post<any>(`${environment.apiUrl}/project/delete-location`, param);
    }

    updateLocation(id, location) {
        return this.http.put<any>(`${environment.apiUrl}/location/update/${id}`, location);
    }

    reverseGeocode(lat: number, lng: number) {
        return this.http.post<any>(`${environment.apiUrl}/location/reverse-geocode`, {lat, lng});
    }

    setCoordinates(id: number, lat: number, lng: number) {
        return this.http.put<any>(`${environment.apiUrl}/location/${id}/coordinates`, {lat, lng});
    }
}
